import { Component, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { APIService } from '../../shared/service/api.service';
import { CursoConvergente } from 'src/app/models/cursoConvergente';
import { removeAccents } from 'src/app/shared/function/remove-accents';
import { treatsNullUndefinedEmpyt } from 'src/app/shared/function/treats-null-undefined-empyt';
import { PagerService } from 'src/app/shared/service/pager.service';
import { BarraBuscaComponent } from 'src/app/shared/barra-busca/barra-busca.component';

@Component({
  selector: 'app-cursos-mudaram-nome',
  templateUrl: './cursos-mudaram-nome-tabela-convergencia.component.html',
  styleUrls: ['./cursos-mudaram-nome-tabela-convergencia.component.scss', './../cursos.component.scss'],
})
export class CursosMudaramNomeTabelaConvergenciaComponent implements OnInit {
  // componenteRef é usado para definir o id da barra de pesquisa, retornando uma
  // referencia de qual componente está chamando o componente "barra-busca"

  @ViewChild(BarraBuscaComponent) novaMensagem: BarraBuscaComponent;

  mensagem = 'Desculpe, não encontramos nenhum resultado compatível com sua busca.';
  componenteRef = 'cursos';
  stringBusca: string;
  deslocamento = 0; // descolamento de página
  paginaAtual: number;
  totalPaginas: number;
  totalResultados: number;
  eixos: string;
  eixo: string;
  ordenacao: string;
  filtro: string;
  queryParamsSubscription: Subscription;
  realizouBusca = false;
  error = false;
  cursosTabelaConvergencia: CursoConvergente[];
  cursosTabelaConvergenciaTemp: CursoConvergente[];
  ativo = false;
  pager: any = {};
  pagedItems: CursoConvergente[];
  msgSemCurso: boolean;
  areaTecnologica: string;
  PAGE_SIZE = 5;
  labelInput = 'Termo de Busca';

  // Modelo do filtro
  filtros: { [key: string]: string } = {
    nomeCursosMudaramNomeCncst: '',
    eixoNome: '',
    nome: ''
  };

  constructor(
    private route: ActivatedRoute,
    private apiService: APIService,
    private pagerService: PagerService) {
  }

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      const {
        cursosTabelaConvergencia: { itens, totalItens },
        cursoError,
        eixosError,
      } = data;

      this.error = cursoError !== undefined || eixosError !== undefined ? true : false;

      if (!this.error) {
        this.cursosTabelaConvergenciaTemp = itens;
        this.montaDadosPaginaCursos(itens); // <
        this.totalResultados = totalItens;

        if (!this.totalResultados || (!this.totalResultados && this.realizouBusca)) {
          this.enviarMensagem(this.mensagem);
        }
      }
    });
  }

  onPaginaSelecionada(numeroPagina: number) {
    this.paginaAtual = numeroPagina;
    this.setPage(numeroPagina);
  }

  recebeuInput(input: any) {
    this.realizouBusca = true;
    this.msgSemCurso = false;
    this.buscaDadosCursosConvergentes(input);
  }

  montaDadosPaginaCursos(cursos: CursoConvergente[]): void {
    if (cursos && cursos.length > 0) {
      this.cursosTabelaConvergencia = cursos;
      this.setPage(1);
      this.totalResultados = this.cursosTabelaConvergencia.length;
      this.msgSemCurso = false;
    } else {
      this.totalResultados = null;
      this.cursosTabelaConvergencia = [];
      this.pager = {};
      this.pagedItems = [];
      this.msgSemCurso = true;
    }
  }

  /**
   *
   * @param page número da pagina.
   * @returns pagina ajustadas.
   */
  setPage(page: number): void {
    const pageSize = this.PAGE_SIZE;
    // Pega o objeto pager do serviço.
    this.pager = this.pagerService.getPager(this.cursosTabelaConvergencia.length, page, pageSize);

    if (page < 1 || page > this.pager.totalPages) {
      return;
    }

    this.paginaAtual = this.pager.currentPage; // <
    this.totalPaginas = this.pager.totalPages; // <

    // Pega a página atual de itens.
    this.pagedItems = this.cursosTabelaConvergencia.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }

  /**
   *
   * @param input para consulta do cache.
   */
  buscaDadosCursosConvergentes(input: any): void {
    if (this.cursosTabelaConvergenciaTemp && this.cursosTabelaConvergenciaTemp.length > 0) {
      this.cursosTabelaConvergencia = this.cursosTabelaConvergenciaTemp;
    }

    const { stringBusca } = input;
    this.stringBusca = stringBusca;

    const filtrosAplicados = {
      cursosMudaramNomeCncst: treatsNullUndefinedEmpyt(stringBusca),
      eixoNome: treatsNullUndefinedEmpyt(stringBusca),
      nome: treatsNullUndefinedEmpyt(stringBusca)
    };

    this.montaDadosPaginaCursos(this.getCursosConvergentesFiltrado(filtrosAplicados));

    if (this.msgSemCurso && this.realizouBusca) {
      this.enviarMensagem(this.mensagem);
    } else {
      this.enviarMensagem('');
    }
  }

  /**
   *
   * @param filtros dinâmicos para consulta de cursos convergentes.
   * @returns lista de objetos correspondente da palavra chave do filtro.
   */
  getCursosConvergentesFiltrado(filtros: { [key: string]: string }): CursoConvergente[] {
    return this.cursosTabelaConvergencia.filter(cursoConvergente =>
      cursoConvergente.cursosMudaramNomeCncst.some((curso: { nome: string; }) =>
        filtros.cursosMudaramNomeCncst ? removeAccents(JSON.stringify(curso.nome))
          .includes(removeAccents(filtros.cursosMudaramNomeCncst)) : true)
      ||
      (filtros.eixoNome ? removeAccents(cursoConvergente.eixoNome).includes(removeAccents(filtros.eixoNome)) : true)
      ||
      (filtros.nome ? removeAccents(cursoConvergente.nome).includes(removeAccents(filtros.nome)) : true)
    ).map(cursoConvergente => cursoConvergente);
  }

  /**
   *
   */
  downloadPdfCursosConvergentes() {
    this.apiService.getDownloadPdfCursosConvergentes().subscribe(
      (data: Blob) => {
        const blob = new Blob([data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'cursosconvergentes.pdf';
        link.click();
      },
      error => {
        console.error('Erro ao baixar o PDF dos cursos de convergência.', error);
      }
    );
  }

  /**
   *
   */
  downloadCsvCursosConvergentes() {
    this.apiService.getDownloadCsvCursosConvergentes()
      .subscribe((data: any) => {
        const blob = new Blob([data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'cursosconvergentes.csv';
        link.click();
      },
        error => {
          console.error('Erro ao baixar o CSV de cursos de convergência.', error);
        });
  }

  /**
   * Envia mensagem para o filho.
   */
  enviarMensagem(mensagem: string) {
    this.novaMensagem.alteraMensagem(mensagem);
  }
}

